import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';
import './OrderImages.css';

// Gjuha e sitit → locale për formatimin e datës
const DATE_LOCALES = { sq: 'sq-AL', en: 'en-GB', de: 'de-DE' };

const OrderImages = () => {
  const { t, lang } = useLanguage();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const orderId = searchParams.get('id');
    if (orderId) {
      const storedOrder = localStorage.getItem(`order_${orderId}`);
      if (storedOrder) {
        setOrderData(JSON.parse(storedOrder));
      }
    }
    setLoading(false);
  }, [searchParams]);

  const downloadImage = (imgData, index) => {
    const link = document.createElement('a');
    link.href = imgData.base64;
    link.download = imgData.originalName || `foto-${index + 1}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadAllImages = () => {
    if (orderData && orderData.images) {
      orderData.images.forEach((img, index) => {
        setTimeout(() => {
          downloadImage(img, index);
        }, index * 500); // Delay between downloads
      });
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>{t('images.loading')}</p>
      </div>
    );
  }

  if (!orderData) {
    return (
      <div className="error-container">
        <h2>{t('images.notFoundTitle')}</h2>
        <p>{t('images.notFoundDesc')}</p>
        <button onClick={() => navigate('/')} className="home-btn">
          {t('success.backHome')}
        </button>
      </div>
    );
  }

  return (
    <div className="order-images-page">
      <Header />
      <div className="images-container">
        <div className="images-header">
          <h1>{t('images.pageTitle')}</h1>
          <button onClick={() => navigate('/')} className="back-home-btn">
            {t('images.back')}
          </button>
        </div>

        <div className="order-info-card">
          <h2>{t('images.cardTitle')}</h2>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">{t('images.orderId')}</span>
              <span className="info-value">{orderData.orderId}</span>
            </div>
            <div className="info-item">
              <span className="info-label">{t('images.photoCount')}</span>
              <span className="info-value">{orderData.images?.length || 0}</span>
            </div>
            <div className="info-item">
              <span className="info-label">{t('images.date')}</span>
              <span className="info-value">
                {new Date(orderData.timestamp).toLocaleString(DATE_LOCALES[lang] || 'sq-AL')}
              </span>
            </div>
          </div>
        </div>

        <div className="download-section">
          <button onClick={downloadAllImages} className="download-all-btn">
            {t('images.downloadAll', { n: orderData.images?.length || 0 })}
          </button>
          <p className="download-hint">
            {t('images.downloadHint')}
          </p>
        </div>

        <div className="images-gallery">
          {orderData.images && orderData.images.length > 0 ? (
            orderData.images.map((img, index) => (
              <div key={index} className="gallery-item">
                <img src={img.base64} alt={t('images.photoWord', { n: index + 1 })} />
                <div className="image-overlay">
                  <button
                    onClick={() => downloadImage(img, index)}
                    className="download-btn"
                  >
                    {t('images.download')}
                  </button>
                  <span className="image-number">
                    {img.originalName || t('images.photoWord', { n: index + 1 })}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div className="no-images">
              <p>{t('images.noImages')}</p>
            </div>
          )}
        </div>

        <div className="footer-actions">
          <button onClick={() => navigate('/')} className="home-btn">
            {t('images.homeBtn')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderImages;
